import groq from 'groq';

export const TagsFragment = groq`
  tags[]->
`;
